import { Schema } from "effect";
export const MeetingStatus = Schema.Struct({
    status: Schema.Literal("Started"),
    interviewerJoined: Schema.Date,
});
